<template>
  <iColumn
    width="fill"
    align="center"
    gap="large"
    data-test="email-unsubscribe-page"
  >
    <iColumn
      width="hug"
      align="center"
      gap="standard"
      :style-overrides="{paddingTop: 'huge', paddingLeft: 'standard', paddingRight: 'standard'}"
    >
      <iDisplayText
        variant="small"
        text-align="center"
        data-test="email-unsubscribe-heading"
      >
        {{ heading }}
      </iDisplayText>
      <iParagraph
        text-align="center"
        data-test="email-unsubscribe-message"
      >
        {{ message }}
      </iParagraph>
      <iButton
        v-if="currentStatus === EMAIL_PREFERENCE_STATUS.SUBSCRIBED"
        variant="primary"
        :is-loading="isSaving"
        data-test="email-unsubscribe-confirm"
        @click="unsubscribe(token)"
      >
        Unsubscribe
      </iButton>
      <iButton
        v-if="currentStatus === EMAIL_PREFERENCE_STATUS.UNSUBSCRIBED"
        variant="secondary"
        :is-loading="isSaving"
        data-test="email-unsubscribe-undo"
        @click="resubscribe(token)"
      >
        Resubscribe
      </iButton>
      <iText
        v-if="saveError"
        variant="error"
        data-test="email-unsubscribe-error"
      >
        {{ saveError }}
      </iText>
    </iColumn>
  </iColumn>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { EMAIL_PREFERENCE_STATUS, useEmailPreferencesStore } from "@/stores/email-preferences-store";

export default {
  name: "EmailUnsubscribe",
  props: {
    token: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    publicationName: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      EMAIL_PREFERENCE_STATUS,
    };
  },
  computed: {
    ...mapState(useEmailPreferencesStore, {
      savedStatus: "status",
      isSaving: "isSaving",
      saveError: "saveError",
    }),
    currentStatus() {
      return this.savedStatus || this.status;
    },
    sender() {
      return this.publicationName || "this publication";
    },
    heading() {
      if (this.currentStatus === EMAIL_PREFERENCE_STATUS.UNSUBSCRIBED) {
        return "You're unsubscribed";
      }
      if (this.currentStatus === EMAIL_PREFERENCE_STATUS.SUBSCRIBED) {
        return "Unsubscribe from these emails?";
      }
      return "This unsubscribe link is invalid";
    },
    message() {
      if (this.currentStatus === EMAIL_PREFERENCE_STATUS.UNSUBSCRIBED) {
        return `You won't get any more emails from ${this.sender}.`;
      }
      if (this.currentStatus === EMAIL_PREFERENCE_STATUS.SUBSCRIBED) {
        return `You'll stop getting emails from ${this.sender}.`;
      }
      return "Please use the unsubscribe link from your most recent email.";
    },
  },
  methods: {
    ...mapActions(useEmailPreferencesStore, ["unsubscribe", "resubscribe"]),
  },
};
</script>
